import { createRef } from 'react';
import {
  accountPath,
  accountProfilePath,
  accountPlanPath,
  accountPaymentPath,
  accountDevicesPath,
  accountScoreCardPath,
  accountMyProsPath,
} from 'src/utils/paths';

export const MENU_ROUTES = [
  { label: 'Orders', route: accountPath() },
  { label: 'My Pros', route: accountMyProsPath() },
  { label: 'Home Scorecard', route: accountScoreCardPath() },
  { label: 'Devices', route: accountDevicesPath() },
  { label: 'Payment', route: accountPaymentPath() },
  { label: 'Member Benefits', route: accountPlanPath() },
  { label: 'Account Info', route: accountProfilePath() },
];

export const ROUTES_REFS = MENU_ROUTES.reduce(
  (refs, routeInfo) => ({ ...refs, [routeInfo.route]: createRef() }),
  {},
);
